document.addEventListener('alpine:init', () => {
    Alpine.data('outagesMap', () => ({
        map: null,
        popId: 0,
        loading: false,
        zoom: 7,
        minZoom: 5,

        get highlightEnabled() {
            return !!(this.map && this.map.getZoom() !== this.minZoom)
        },

        init: function () {
            setTimeout(() => {
                let isMobile = L.Browser.mobile
                this.zoom = isMobile ? 7 : 8
                this.minZoom = isMobile ? 4 : 6

                this.map =
                    L.map(
                            this.$el.querySelector('.leaf-map'),
                            {
                                gestureHandling: isMobile
                            }
                        )
                        .setView([-41.3745, 172.4663], 5)


                let tile = L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
                    maxZoom: this.zoom,
                    minZoom: this.minZoom,
                    attribution: '',
                    maxBoundsViscosity: 1.0,
                    priority: 0.1,
                    useCache: true,
                    crossOrigin: true,
                    opacity: 0,
                })


                // Capture error if L.LatLngBounds or tile.seed is not defined
                if (typeof L.LatLngBounds === 'undefined' || typeof tile.seed === 'undefined') {
                    sendErrorToSentry(new TypeError('L.LatLngBounds or tile.seed is not defined'), {
                        culprit: '/outages',
                        filename: 'resources/js/outages-map.js',
                        function: 'init',
                        message: 'Attempted to call tile.seed or use L.LatLngBounds when not defined.'
                    })
                } else {
                    let bounds = L.LatLngBounds(this.map.getBounds())
                    tile.seed(bounds, 5, 10)
                }

                tile.addTo(this.map)


                this.map.setMaxBounds(this.map.getBounds())

                this.loadMapLayers()
            }, 500)

        },

        loadMapLayers: function () {
            fetch('/outages/map-data').then(d => d.json()).then((d) => {
                L.geoJSON(d.features, {
                    style: function () {
                        return {
                            color: '#81D3EB',
                            fillColor: '#54C4C7',
                            weight: 1,
                            opacity: 1,
                            fillOpacity: 1
                        }
                    },

                    onEachFeature: (feature, layer) => {
                        layer.on('mouseover', function () {
                            if (this._popup && this._popup.isOpen()) {
                                return
                            }

                            if (this.feature.properties.ID === 'GBI' || this.feature.properties.ID === 'LBI') {
                                return
                            }

                            if (layer._map.getZoom() > 5) {
                                this.setStyle({
                                    'fillColor': '#078B8D'
                                })
                            }
                        })


                        const resetColour = (e) => {
                            if (this.popId === e.target._leaflet_id && e.type !== 'popupclose') {
                                return
                            }

                            if (this.popId === e.target._leaflet_id && e.type === 'popupclose') {
                                this.popId = 0
                            }


                            e.target.setStyle({
                                'fillColor': '#54C4C7'
                            })
                        }

                        layer.on('mouseout', resetColour)
                        layer.on('popupclose', resetColour)
                        layer.on('popupopen', (e) => e.target.setStyle({ 'fillColor': '#078B8D' }))

                        layer.on('click', async (e) => {
                            if (this.highlightEnabled) {
                                if (e.sourceTarget.feature.properties.ID === 'GBI' || e.sourceTarget.feature.properties.ID === 'LBI') {
                                    return
                                }

                                this.loading = true
                                await fetch('/outages/details/' + encodeURIComponent(e.target.feature.properties.Region))
                                    .then(d => d.text())
                                    .then(d => {
                                        this.popId = layer._leaflet_id
                                        layer.bindPopup(d).openPopup()
                                        this.loading = false
                                    })
                            } else {
                                layer._map.zoomIn()
                            }
                        })
                    }
                }).addTo(this.map)
            })
        },

        handleSearch() {
            const result = this.$event.detail
            const latlng = new L.LatLng(result[0], result[1])
            this.map.flyTo(latlng, this.zoom)

            this.map.once('moveend', () => {
                let closestLayer = null
                let closestDistance = Infinity
                this.map.eachLayer((layer) => {
                    if (layer.getBounds && layer.getBounds().contains(latlng)) {
                        const distance = layer.getBounds().getCenter().distanceTo(latlng)
                        if (distance < closestDistance) {
                            closestLayer = layer
                            closestDistance = distance
                        }
                    }
                })

                closestLayer.fire('click')
            })
        }
    }))
})